import DivStyle from "../../components/style/div.component";
import SmallForm from "../../components/form/small_form";
import { useEffect, useState } from "react";
import { useSetRecoilState } from "recoil";
import { loadingState } from "../../recoil/loading.atom";
import { FormProps } from "../../components/form/interface/formInterface";
import AdminAPI from "../../api/admin";
import { ImagePopupResponse } from "../../api/admin/image-popup";
import { formatDate } from "../club/utils/excelExport";
import Table from "../../components/table/Table";

const ImagePopup = () => {
  const [imagePopupList, setImagePopupList] = useState<ImagePopupResponse[]>(
    [],
  );
  const setIsLoading = useSetRecoilState(loadingState);
  const [mode, setMode] = useState("V");
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [id, setId] = useState(0);
  const [imagePath, setImagePath] = useState("");
  const [file, setFile] = useState(null);
  const [ord, setOrd] = useState(0);
  const [buttonText, setButtonText] = useState("");
  const [buttonUrl, setButtonUrl] = useState("");

  const formData: FormProps = {
    title: "폼",
    form: [
      {
        value: ord,
        setValue: setOrd,
        label: "순서",
        width: "100%",
        type: mode === "U" ? "input" : "input-dash",
      },
      {
        value: startDate,
        setValue: setStartDate,
        label: "시작일",
        width: "100%",
        type: "date",
      },
      {
        value: endDate,
        setValue: setEndDate,
        label: "종료일",
        width: "100%",
        type: "date",
      },
      {
        value: buttonText,
        setValue: setButtonText,
        label: "버튼 텍스트",
        width: "100%",
        type: "input",
      },
      {
        value: buttonUrl,
        setValue: setButtonUrl,
        label: "버튼 링크",
        width: "100%",
        type: "input",
      },
      {
        value: file,
        setValue: setFile,
        label: "사진",
        width: "100%",
        type: "file",
      },
      {
        value: imagePath,
        setValue: setImagePath,
        label: "이미지",
        width: "100%",
        type: "image",
      },
    ],
  };

  const headers = [
    {
      text: "순번",
      align: "center",
      sortable: false,
      value: "ord",
    },
    {
      text: "이미지 경로",
      align: "start",
      sortable: false,
      value: "imagePath",
    },
    {
      text: "버튼 텍스트",
      align: "start",
      sortable: false,
      value: "buttonText",
    },
    {
      text: "버튼 링크",
      align: "start",
      sortable: false,
      value: "buttonUrl",
    },
    { text: "시작일", align: "center", sortable: false, value: "startDate" },
    { text: "종료일", align: "center", sortable: false, value: "endDate" },
  ];

  const setDetail = async (item: ImagePopupResponse) => {
    setMode("U");
    setId(item.id);
    setOrd(item.ord);
    setImagePath(item.imagePath);
    setButtonText(item.buttonText);
    setButtonUrl(item.buttonUrl);
    setStartDate(item.startDate ? formatDate(item.startDate) : null);
    setEndDate(item.endDate ? formatDate(item.endDate) : null);
  };
  const addForm = () => {
    setMode("I");
    setId(0);
    setOrd(0);
    setImagePath("");
    setButtonText("");
    setButtonUrl("");
    setStartDate(null);
    setEndDate(null);
    setFile(null);
  };
  const save = async () => {
    const formData = new FormData();
    if (file) {
      formData.append("file", file);
    }
    const body = {
      buttonText,
      buttonUrl,
      startDate,
      endDate,
      ord,
    };
    formData.append("data", JSON.stringify(body));

    if (window.confirm("저장 하시겠습니까?")) {
      setIsLoading(true);
      const res_meta = await AdminAPI.updateImagePopup(id, formData);
      if (res_meta && res_meta.status === 200) {
        alert("저장되었습니다.");
        addForm();
        getImagePopupList();
      }
    }
    setIsLoading(false);
  };

  const remove = async () => {
    if (window.confirm("삭제 하시겠습니까?")) {
      setIsLoading(true);
      const res = await AdminAPI.deleteImagePopup(id);
      if (res && res.status === 200) {
        alert("삭제 되었습니다.");
        getImagePopupList();
        addForm();
      }
    }
    setIsLoading(false);
  };
  const add = async () => {
    if (!file) {
      alert("이미지를 선택해주세요.");
      return;
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    const body = {
      buttonText,
      buttonUrl,
      startDate,
      endDate,
    };
    formData.append("data", JSON.stringify(body));

    const res = await AdminAPI.registerImagePopup(formData);
    if (res) {
      alert("신규 등록이 되었습니다.");
      getImagePopupList();
      addForm();
    }

    setIsLoading(false);
  };

  const getImagePopupList = async () => {
    const res = await AdminAPI.getImagePopupList();
    if (res && res.status === 200) {
      setImagePopupList(res.data);
    }
  };
  useEffect(() => {
    getImagePopupList();
  }, []);
  return (
    <DivStyle
      style={{ overflow: "auto" }}
      backgroundColor="#121212"
      height="100vh"
      display="flex"
      flex_direction="row"
      marginTop="65px"
      setMobile={true}
    >
      <DivStyle
        width="66%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileTable={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>
          이미지 팝업
        </h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="20px"
        >
          <DivStyle
            width="100%"
            display="flex"
            flex_direction="row"
            justify_content="space-between"
            align_items="center"
          >
            <DivStyle
              width="100%"
              display="flex"
              flex_direction="row"
              justify_content="end"
              align_items="center"
            ></DivStyle>
          </DivStyle>

          <Table
            addForm={addForm}
            headers={headers}
            currentPage={1}
            dataList={imagePopupList}
            setDetail={setDetail}
            setDataList={setImagePopupList}
            getDatas={getImagePopupList}
          />
        </DivStyle>
      </DivStyle>
      <DivStyle
        width="33%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileForm={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>폼</h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <SmallForm
            form={formData.form}
            title={formData.title}
            save={save}
            add={add}
            mode={mode}
            remove={remove}
          />
        </DivStyle>
      </DivStyle>
    </DivStyle>
  );
};

export default ImagePopup;
